import React from 'react'
import Loader from 'react-loader-spinner'

const Spinner = () => {
  return (
    <div className="spinner">
      <Loader type="Oval" color="#000000" height={50} width={50} />
    </div>
  )
}

export default Spinner
